import { useQuery } from '@tanstack/react-query';

import { ADMIN_API_URL_SUBPATH } from '@/constants';
import { ALLERGEN, Allergen, axiosInstance } from '@/core';

export const useAllergens = () => {
  const fullUrl = `${ADMIN_API_URL_SUBPATH}/${ALLERGEN}`;

  const allergensResult = useQuery<Allergen[]>({
    queryKey: ['allergens'],
    queryFn: () => axiosInstance.get(fullUrl).then((res) => res.data),
  });

  return {
    allergensResult,
  };
};
